module.exports = __webpack_public_path__ + "media/images/loading-a7f6f906.gif";